import React from "react";
import "aos/dist/aos.css";

const ServicesCard = ({ bgcolor, heading, paragraph, image, imagemeta }) => {
  return (
    <>
      {/* base container */}
      <div
        data-aos="fade-up"
        className="my-2 h-80 lg:h-96 px-6 sm:px-0 sm:mx-20 md:mx-2 lg:mx-3 transform -translate-y-28 mt-16 sm:mt-10 md:mt-32 lg:mt-10"
      >
        {/* service paragraph card */}
        <div
          className={`${bgcolor} h-72 sm:h-64 md:h-80 xl:h-80 w-full transform translate-y-20 rounded-lg bg-white`}
        >
          <div className="transform translate-y-20 md:translate-y-24 lg:translate-y-20 xl:translate-y-28 px-4 py-2">
            {/* heading  */}
            <div className="text-black text-md font-body font-bold uppercase lg:text-[22px] py-2">
              {heading}
            </div>
            {/* paragraph */}
            <div className="text-[#505050] font-body font-normal text-sm text-justify py-2 xl:text-sm tracking-wider sm:text-sm">
              {paragraph}
            </div>
          </div>
        </div>
        {/* image card */}
        <div className="transform px-3 -translate-y-72 sm:-translate-y-64 md:-translate-y-[310px] lg:-translate-y-[350px] xl:-translate-y-[300px] lg:px-6 ">
          <img
            src={image}
            alt={imagemeta}
            className="h-40 lg:h-44 w-full object-cover rounded-md shadow-md shadow-black"
          />
        </div>
      </div>
    </>
  );
};

export default ServicesCard;
